import { ToolbarSeparator, ToolbarToggleButton } from "@prismicio/editor-ui"
import type { Editor } from "@tiptap/core"

import type { MenuItem } from "../models/MenuItems"

interface ExtraItemsProps {
  items: MenuItem[]
  editor: Editor
}

export function ExtraItems(props: ExtraItemsProps) {
  const { items, editor } = props

  if (items.length === 0) return null

  return (
    <>
      <ToolbarSeparator />
      {items.map((item) => (
        <ToolbarToggleButton
          disabled={!item.runCommands(editor, { can: true })}
          key={item.nodeType}
          onPressedChange={() => {
            item.runCommands(editor)
          }}
          pressed={item.isActive(editor)}
          startIcon={item.icon}
        />
      ))}
    </>
  )
}
